import React from 'react';

import InfoNote from '../../utils/InfoNote';

type Props = {
  onClose(): void;
};

export default function SuccessMessagePage(props: Props) {
  return (
    <>
      <header>
        <h4>Request a refund</h4>
      </header>
      <main>
        <div className='request-refund-modal__page-content'>
          <InfoNote variant='success' faIcon='fa-check-circle-o'>
            <p>The refund request has been submitted.</p>
            <p>
              It will be reviewed and approved by a manager before the customer
              receives the refund.
            </p>
          </InfoNote>
        </div>
      </main>
      <footer className='modal__footer'>
        <menu className='modal__actions modal__actions--center'>
          <button
            key='editOrder'
            className='btn btn-primary btn--wide'
            type='button'
            onClick={props.onClose}
          >
            Back to Order
          </button>
        </menu>
      </footer>
    </>
  );
}
